import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Badge from './Badge';
import Button from './Button';
import vehicles from './vehicles';
import ReservationPanel from './ReservationPanel';
import './VehicleDetail.css';

function VehicleDetail() {
  const { slug } = useParams();
  const vehicle = vehicles.find((candidate) => candidate.slug === slug);
  const [activeImage, setActiveImage] = useState(0);

  if (!vehicle) {
    return (
      <section className="vehicle-detail">
        <p>
          We couldn't find that vehicle. <Link to="/fleet">Back to the fleet</Link>.
        </p>
      </section>
    );
  }

  const mainImage = vehicle.images[activeImage];

  function focusThumbnail(index) {
    const wrapped = (index + vehicle.images.length) % vehicle.images.length;
    setActiveImage(wrapped);
    const gallery = document.getElementById(`${vehicle.slug}-thumbnails`);
    gallery?.querySelectorAll('button')[wrapped]?.focus();
  }

  function handleThumbnailKeyDown(event) {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      focusThumbnail(activeImage + 1);
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      focusThumbnail(activeImage - 1);
    }
  }

  return (
    <section className="vehicle-detail">
      <nav className="vehicle-detail__breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link> / <Link to="/fleet">Fleet</Link> / {vehicle.name}
      </nav>

      <div className="vehicle-detail__layout">
        <div className="vehicle-detail__gallery">
          {mainImage ? (
            <img className="vehicle-detail__main-image" src={mainImage} alt={vehicle.imageAlt} />
          ) : (
            <div className="vehicle-detail__main-image vehicle-detail__main-image--placeholder">
              Photos coming soon
            </div>
          )}
          {vehicle.images.length > 1 && (
            <div
              id={`${vehicle.slug}-thumbnails`}
              className="vehicle-detail__thumbnails"
              role="group"
              aria-label="Vehicle photos"
              onKeyDown={handleThumbnailKeyDown}
            >
              {vehicle.images.map((image, index) => (
                <button
                  key={image}
                  type="button"
                  tabIndex={index === activeImage ? 0 : -1}
                  className={`vehicle-detail__thumbnail${
                    index === activeImage ? ' vehicle-detail__thumbnail--active' : ''
                  }`}
                  style={{ backgroundImage: `url(${image})` }}
                  aria-label={`View photo ${index + 1} of ${vehicle.name}`}
                  aria-pressed={index === activeImage}
                  onClick={() => setActiveImage(index)}
                />
              ))}
            </div>
          )}
        </div>

        <div className="vehicle-detail__panel">
          <h1>{vehicle.name}</h1>
          <div className="vehicle-detail__meta">
            <span className="vehicle-detail__price">
              {vehicle.price || 'Contact for pricing'}
            </span>
            <Badge status={vehicle.status} />
          </div>

          <div className="vehicle-detail__ctas">
            <Button variant="primary" href="#reserve">
              Request to Reserve
            </Button>
          </div>

          <dl className="vehicle-detail__specs">
            <div>
              <dt>Range</dt>
              <dd>{vehicle.specs.range}</dd>
            </div>
            <div>
              <dt>Seats</dt>
              <dd>{vehicle.specs.seats}</dd>
            </div>
            <div>
              <dt>Drivetrain</dt>
              <dd>{vehicle.specs.drivetrain}</dd>
            </div>
          </dl>
        </div>
      </div>

      <div id="reserve">
        <ReservationPanel vehicleSlug={vehicle.slug} />
      </div>
    </section>
  );
}

export default VehicleDetail;
